import { render } from "./Quotation4.vue?vue&type=template&id=4e0400da"
import script from "./Quotation4.vue?vue&type=script&lang=js"
export * from "./Quotation4.vue?vue&type=script&lang=js"
script.render = render

export default script